import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const apiSlice = createApi({
  reducerPath: "apiSlice",
  baseQuery: customBaseQuery,
  endpoints: () => ({})
});
